module.exports = __webpack_public_path__ + "img/send_invoice.569c3da4.svg";